// // src/pages/SoftwareDevelopment.js
// import React, { useState } from "react";
// import "./SoftwareDevelopment.css";

// import {
//   FaCode,
//   FaGlobe,
//   FaMobileAlt,
//   FaShoppingBag,
//   FaCalendarAlt,
//   FaBug,
//   FaLayerGroup,
//   FaServer,
//   FaDatabase,
//   FaCloud,
//   FaShieldAlt,
//   FaBolt,
//   FaChartLine,
//   FaPencilRuler,
//   FaCogs,
//   FaVial,
//   FaHeadset,
//   FaUsers,
//   FaThumbsUp,
//   FaClipboardCheck,
//   FaSmile,
//   FaClock,
//   FaComments,
// } from "react-icons/fa";
// import { Link } from "react-router-dom";
// import SoftwareDevelopments from "../../images/software development.jpg";

// const TABS = [
//   {
//     id: "services",
//     label: "Services",
//     items: [
//       {
//         icon: <FaCode />,
//         title: "Custom Software Development",
//         desc: "Design and build business-critical web & desktop applications around your exact workflows.",
//       },
//       {
//         icon: <FaGlobe />,
//         title: "Website Design & Development",
//         desc: "High-performance, SEO-friendly websites that tell your brand story and convert visitors.",
//       },
//       {
//         icon: <FaMobileAlt />,
//         title: "Mobile Application Development",
//         desc: "High-quality Android & cross-platform apps tailored for speed, security, and scale.",
//       },
//       {
//         icon: <FaShoppingBag />,
//         title: "E-Commerce Solutions",
//         desc: "End-to-end storefronts, custom catalog flows, and secure payment integrations.",
//       },
//       {
//         icon: <FaCalendarAlt />,
//         title: "Product Maintenance & Support",
//         desc: "Version upgrades, refactors, and ongoing optimizations to keep your software healthy.",
//       },
//       {
//         icon: <FaBug />,
//         title: "QA & Testing",
//         desc: "Functional, regression, performance, and security testing for stable releases.",
//       },
//     ],
//   },
//   {
//     id: "frontend",
//     label: "Frontend Technologies",
//     items: [
//       {
//         icon: <FaLayerGroup />,
//         title: "React / Next.js UI",
//         desc: "Modern component-based frontends with smooth animations and reusable design systems.",
//       },
//       {
//         icon: <FaMobileAlt />,
//         title: "React Native Apps",
//         desc: "Shared codebase apps for Android & iOS with native-like performance.",
//       },
//       {
//         icon: <FaGlobe />,
//         title: "SPA & PWA",
//         desc: "Single-page and progressive web apps for app-like experiences in the browser.",
//       },
//       {
//         icon: <FaBolt />,
//         title: "Performance Optimization",
//         desc: "Lazy loading, code-splitting, and Core Web Vitals tuning.",
//       },
//       {
//         icon: <FaChartLine />,
//         title: "Analytics-ready UI",
//         desc: "Event tracking hooks and dashboards wired for insights.",
//       },
//       {
//         icon: <FaShieldAlt />,
//         title: "Secure Frontends",
//         desc: "Safe auth flows, protected routes, and hardened forms.",
//       },
//     ],
//   },
//   {
//     id: "backend",
//     label: "Backend Technologies",
//     items: [
//       {
//         icon: <FaServer />,
//         title: "Node.js / Express APIs",
//         desc: "REST APIs, microservices, and background jobs for any business workflow.",
//       },
//       {
//         icon: <FaDatabase />,
//         title: "Relational Data Models",
//         desc: "Well-designed schemas, migrations, and indexing for PostgreSQL/MySQL.",
//       },
//       {
//         icon: <FaCloud />,
//         title: "Cloud-Native Backends",
//         desc: "Containerized workloads, autoscaling, and infra as code.",
//       },
//       {
//         icon: <FaShieldAlt />,
//         title: "Security & Compliance",
//         desc: "JWT, RBAC, audit trails, and secure secrets management.",
//       },
//       {
//         icon: <FaBolt />,
//         title: "High-Throughput APIs",
//         desc: "Caching, queuing, and rate-limiting for demanding workloads.",
//       },
//       {
//         icon: <FaChartLine />,
//         title: "Monitoring & Observability",
//         desc: "Logs, metrics, and alerts wired to your cloud stack.",
//       },
//     ],
//   },
//   {
//     id: "database",
//     label: "Database & Testing",
//     items: [
//       {
//         icon: <FaDatabase />,
//         title: "PostgreSQL / MySQL",
//         desc: "Relational database design, migrations, indexing, and query optimization.",
//       },
//       {
//         icon: <FaDatabase />,
//         title: "MongoDB & NoSQL",
//         desc: "Flexible schemas for event logs, analytics, and high-volume workloads.",
//       },
//       {
//         icon: <FaBolt />,
//         title: "Caching & Performance",
//         desc: "Redis-based layers to keep APIs fast and responsive.",
//       },
//       {
//         icon: <FaLayerGroup />,
//         title: "Data Pipelines",
//         desc: "Ingestion, transformation, and scheduled jobs for reporting and BI.",
//       },
//       {
//         icon: <FaCloud />,
//         title: "Backup & DR Strategy",
//         desc: "Automated backups, restore drills, and disaster-recovery playbooks.",
//       },
//       {
//         icon: <FaBug />,
//         title: "Testing & Monitoring",
//         desc: "Load tests, integration tests, and live monitoring dashboards.",
//       },
//     ],
//   },
// ];

// // development process
// const PROCESS_STEPS = [
//   {
//     icon: <FaPencilRuler />,
//     label: "01. Design",
//     text: "UX research, wireframes, and clean interface design for web and mobile.",
//   },
//   {
//     icon: <FaCogs />,
//     label: "02. Programming",
//     text: "Structured engineering with standardised coding, reviews, and version control.",
//   },
//   {
//     icon: <FaVial />,
//     label: "03. Testing",
//     text: "Automated + manual testing to ensure each release is stable and predictable.",
//   },
//   {
//     icon: <FaHeadset />,
//     label: "04. Delivery & Support",
//     text: "Deployment, monitoring, and ongoing support to keep your product future-ready.",
//   },
// ];

// // why choose us
// const WHY_POINTS = [
//   {
//     icon: <FaUsers />,
//     title: "Reliable in-house team",
//     text: "Experienced engineers at Aazira Solutions working closely with you.",
//   },
//   {
//     icon: <FaThumbsUp />,
//     title: "Trusted by people like you",
//     text: "Projects delivered for SMEs, startups, and growing businesses.",
//   },
//   {
//     icon: <FaClipboardCheck />,
//     title: "Complete technical competency",
//     text: "Full-stack expertise from UI to database and cloud infrastructure.",
//   },
//   {
//     icon: <FaSmile />,
//     title: "Friendly & collaborative",
//     text: "Clear communication, regular demos, and no surprise decisions.",
//   },
//   {
//     icon: <FaClock />,
//     title: "Quality delivered on time",
//     text: "Agile sprints, realistic estimates, and disciplined project planning.",
//   },
//   {
//     icon: <FaComments />,
//     title: "Effective, continuous communication",
//     text: "Slack/Teams/Meet updates so you always know the project status.",
//   },
// ];

// export default function SoftwareDevelopment() {
//   const [activeTab, setActiveTab] = useState("services");
//   const currentTab = TABS.find((t) => t.id === activeTab) ?? TABS[0];

//   return (
//     <div className="sd-page">
//       {/* ========= HERO ========= */}
//       <section className="sd-hero">
//         <div className="sd-hero-inner">
//           <div className="sd-hero-text">
//             <p className="sd-hero-kicker">SOFTWARE DEVELOPMENT SERVICES</p>
//             <h1 className="sd-hero-title">
//               Build, scale & modernize
//               <br />
//               your <span>business-critical software</span>
//             </h1>
//             <p className="sd-hero-sub">
//               From idea to deployment, we design and develop secure, scalable
//               applications for web, mobile, and cloud — aligned with your
//               processes and growth plans.
//             </p>

//             <ul className="sd-hero-bullets">
//               <li>✔ Custom business software and modules tailored to you</li>
//               <li>
//                 ✔ Modern tech stack with React, Node.js, PostgreSQL, and cloud
//                 hosting
//               </li>
//               <li>✔ Dedicated team for long-term support and enhancements</li>
//             </ul>

//             <div className="sd-hero-cta-row">
//               <Link to="/products">
//                 <button className="sd-hero-cta-primary">
//                   Discuss Your Project
//                 </button>
//               </Link>

//               <Link to="/products">
//                 <button className="sd-hero-cta-secondary">
//                   View Delivery Approach
//                 </button>
//               </Link>
//             </div>
//           </div>

//           <div className="dm-hero-visual">
//             <img
//               src={SoftwareDevelopments}
//               alt="Hero Visual"
//               className="dm-hero-image"
//             />
//           </div>
//         </div>

//         {/* stats strip */}
//         <div className="sd-hero-stats-strip">
//           <div className="sd-hero-stats-container">
//             <div className="sd-hero-stat">
//               <div className="sd-hero-stat-icon">👨‍💻</div>
//               <div className="sd-hero-stat-text">
//                 <span className="sd-hero-stat-number">55+</span>
//                 <span className="sd-hero-stat-label">Software Developed</span>
//               </div>
//             </div>
//             <div className="sd-hero-stat">
//               <div className="sd-hero-stat-icon">🖥️</div>
//               <div className="sd-hero-stat-text">
//                 <span className="sd-hero-stat-number">62+</span>
//                 <span className="sd-hero-stat-label">Websites Developed</span>
//               </div>
//             </div>
//             <div className="sd-hero-stat">
//               <div className="sd-hero-stat-icon">📱</div>
//               <div className="sd-hero-stat-text">
//                 <span className="sd-hero-stat-number">25+</span>
//                 <span className="sd-hero-stat-label">Apps Developed</span>
//               </div>
//             </div>
//             <div className="sd-hero-stat">
//               <div className="sd-hero-stat-icon">🤝</div>
//               <div className="sd-hero-stat-text">
//                 <span className="sd-hero-stat-number">100+</span>
//                 <span className="sd-hero-stat-label">Projects Delivered</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* ========= WHAT WE OFFER ========= */}
//       <section className="sd-offer">
//         <div className="sd-offer-header">
//           <h2>What We Offer</h2>
//           <p>
//             A complete software development stack — from clean interfaces to
//             high-performing backends and reliable data layers.
//           </p>
//         </div>

//         <div className="sd-tabs">
//           {TABS.map((tab) => (
//             <button
//               key={tab.id}
//               className={`sd-tab ${activeTab === tab.id ? "active" : ""}`}
//               onClick={() => setActiveTab(tab.id)}
//             >
//               {tab.label}
//             </button>
//           ))}
//         </div>
//         <div className="sd-tabs-underline" />

//         <div className="sd-tab-grid-wrapper">
//           <div className="sd-tab-grid">
//             {currentTab.items.map((item, index) => (
//               <article
//                 key={item.title}
//                 className={`sd-tab-card ${
//                   index === 1 || index === 4 ? "featured" : ""
//                 }`}
//               >
//                 <div className="sd-tab-icon">{item.icon}</div>
//                 <h3 className="sd-tab-title">{item.title}</h3>
//                 <p className="sd-tab-desc">{item.desc}</p>
//               </article>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ========= DEVELOPMENT PROCESS ========= */}
//       <section className="sd-process">
//         <div className="sd-process-inner">
//           <h3 className="sd-process-heading">Our Development Process</h3>

//           <div className="sd-process-grid">
//             {PROCESS_STEPS.map((step) => (
//               <div key={step.label} className="sd-process-item">
//                 <div className="sd-process-icon-wrap">
//                   <span className="sd-process-icon">{step.icon}</span>
//                 </div>
//                 <h4 className="sd-process-label">{step.label}</h4>
//                 <p className="sd-process-text">{step.text}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ========= WHY CHOOSE Aazira Solutions ========= */}
//       <section className="sd-why">
//         <div className="sd-why-inner">
//           <h3 className="sd-why-heading">
//             Why Choose Aazira Solutions for Software Development?
//           </h3>

//           <div className="sd-why-grid">
//             {WHY_POINTS.map((item) => (
//               <div key={item.title} className="sd-why-card">
//                 <div className="sd-why-icon">{item.icon}</div>
//                 <h4 className="sd-why-title">{item.title}</h4>
//                 <p className="sd-why-text">{item.text}</p>
//               </div>
//             ))}
//           </div>

//           {/* <div className="sd-why-cta-row">
//             <p className="sd-why-cta-text">
//               Let&apos;s start a <span>new project</span> together.
//             </p>
//             <button className="sd-why-cta-btn">Enquire Now</button>
//           </div> */}
//           <div className="sd-why-cta-row">
//             <p className="sd-why-cta-text">
//               Let&apos;s start a <span>new project</span> together.
//             </p>

//             <Link to="/contact">
//               <button className="sd-why-cta-btn">Enquire Now</button>
//             </Link>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }






// src/pages/SoftwareDevelopment.js
import React, { useState } from "react";
import "./SoftwareDevelopment.css";

import {
  FaCode,
  FaGlobe,
  FaMobileAlt,
  FaShoppingBag,
  FaCalendarAlt,
  FaBug,
  FaLayerGroup,
  FaServer,
  FaDatabase,
  FaCloud,
  FaShieldAlt,
  FaBolt,
  FaChartLine,
  FaPencilRuler,
  FaVial,
  FaUsers,
  FaThumbsUp,
  FaClipboardCheck,
  FaSmile,
  FaClock,
  FaComments,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import SoftwareDevelopments from "../../images/software development.jpg";
import { SiTrello } from "react-icons/si";

const TABS = [
  {
    id: "services",
    label: "Services",
    items: [
      {
        icon: <FaCode />,
        title: "Custom Software Development",
        desc: "Design and build business-critical web & desktop applications around your exact workflows.",
      },
      {
        icon: <FaGlobe />,
        title: "Website Design & Development",
        desc: "High-performance, SEO-friendly websites that tell your brand story and convert visitors.",
      },
      {
        icon: <FaMobileAlt />,
        title: "Mobile Application Development",
        desc: "High-quality Android & cross-platform apps tailored for speed, security, and scale.",
      },
      {
        icon: <FaShoppingBag />,
        title: "E-Commerce Solutions",
        desc: "End-to-end storefronts, custom catalog flows, and secure payment integrations.",
      },
      {
        icon: <FaCalendarAlt />,
        title: "Product Maintenance & Support",
        desc: "Version upgrades, refactors, and ongoing optimizations to keep your software healthy.",
      },
      {
        icon: <FaBug />,
        title: "QA & Testing",
        desc: "Functional, regression, performance, and security testing for stable releases.",
      },
    ],
  },
  {
    id: "frontend",
    label: "Frontend Technologies",
    items: [
      {
        icon: <FaLayerGroup />,
        title: "React / Next.js UI",
        desc: "Modern component-based frontends with smooth animations and reusable design systems.",
      },
      {
        icon: <FaMobileAlt />,
        title: "React Native Apps",
        desc: "Shared codebase apps for Android & iOS with native-like performance.",
      },
      {
        icon: <FaGlobe />,
        title: "SPA & PWA",
        desc: "Single-page and progressive web apps for app-like experiences in the browser.",
      },
      {
        icon: <FaBolt />,
        title: "Performance Optimization",
        desc: "Lazy loading, code-splitting, and Core Web Vitals tuning.",
      },
      {
        icon: <FaChartLine />,
        title: "Analytics-ready UI",
        desc: "Event tracking hooks and dashboards wired for insights.",
      },
      {
        icon: <FaShieldAlt />,
        title: "Secure Frontends",
        desc: "Safe auth flows, protected routes, and hardened forms.",
      },
    ],
  },
  {
    id: "backend",
    label: "Backend Technologies",
    items: [
      {
        icon: <FaServer />,
        title: "Node.js / Express APIs",
        desc: "REST APIs, microservices, and background jobs for any business workflow.",
      },
      {
        icon: <FaDatabase />,
        title: "Relational Data Models",
        desc: "Well-designed schemas, migrations, and indexing for PostgreSQL/MySQL.",
      },
      {
        icon: <FaCloud />,
        title: "Cloud-Native Backends",
        desc: "Containerized workloads, autoscaling, and infra as code.",
      },
      {
        icon: <FaShieldAlt />,
        title: "Security & Compliance",
        desc: "JWT, RBAC, audit trails, and secure secrets management.",
      },
      {
        icon: <FaBolt />,
        title: "High-Throughput APIs",
        desc: "Caching, queuing, and rate-limiting for demanding workloads.",
      },
      {
        icon: <FaChartLine />,
        title: "Monitoring & Observability",
        desc: "Logs, metrics, and alerts wired to your cloud stack.",
      },
    ],
  },
  {
    id: "database",
    label: "Database & Testing",
    items: [
      {
        icon: <FaDatabase />,
        title: "PostgreSQL / MySQL",
        desc: "Relational database design, migrations, indexing, and query optimization.",
      },
      {
        icon: <FaDatabase />,
        title: "MongoDB & NoSQL",
        desc: "Flexible schemas for event logs, analytics, and high-volume workloads.",
      },
      {
        icon: <FaBolt />,
        title: "Caching & Performance",
        desc: "Redis-based layers to keep APIs fast and responsive.",
      },
      {
        icon: <FaLayerGroup />,
        title: "Data Pipelines",
        desc: "Ingestion, transformation, and scheduled jobs for reporting and BI.",
      },
      {
        icon: <FaCloud />,
        title: "Backup & DR Strategy",
        desc: "Automated backups, restore drills, and disaster-recovery playbooks.",
      },
      {
        icon: <FaBug />,
        title: "Testing & Monitoring",
        desc: "Load tests, integration tests, and live monitoring dashboards.",
      },
    ],
  },
];

const PROCESS_STEPS = [
{
    icon: <SiTrello />,
    label: "I. Requirement Gathering",
    text: "Understand client needs, analyze requirements, and document specifications.",
  },
  {
    icon: <FaPencilRuler />,
    label: "II. Design",
    text: "Creating wireframes, prototypes, and system designs based on gathered requirements.",
  },
  {
    icon: <FaCode />,
    label: "III. Development",
    text: "Writing code based on design, testing the modules in an iterative approach.",
  },
  {
    icon: <FaVial />,
    label: "IV. Testing",
    text: "Continuous testing and bug fixing of the developed product for stability.",
  },
  {
    icon: <FaCloud />,
    label: "V. Deployment",
    text: "Deploy the final product and provide post-launch support and monitoring.",
  },
  {
    icon: <FaUsers />,
    label: "VI. Feedback & Iteration",
    text: "Gather user feedback and improve the system by adding new features or enhancing existing ones.",
  },
];

const WHY_POINTS = [
  {
    icon: <FaUsers />,
    title: "Reliable in-house team",
    text: "Experienced engineers at Aazira Solutions working closely with you.",
  },
  {
    icon: <FaThumbsUp />,
    title: "Trusted by people like you",
    text: "Projects delivered for SMEs, startups, and growing businesses.",
  },
  {
    icon: <FaClipboardCheck />,
    title: "Complete technical competency",
    text: "Full-stack expertise from UI to database and cloud infrastructure.",
  },
  {
    icon: <FaSmile />,
    title: "Friendly & collaborative",
    text: "Clear communication, regular demos, and no surprise decisions.",
  },
  {
    icon: <FaClock />,
    title: "Quality delivered on time",
    text: "Agile sprints, realistic estimates, and disciplined project planning.",
  },
  {
    icon: <FaComments />,
    title: "Effective, continuous communication",
    text: "Slack/Teams/Meet updates so you always know the project status.",
  },
];

export default function SoftwareDevelopment() {
  const [activeTab, setActiveTab] = useState("services");
  const currentTab = TABS.find((t) => t.id === activeTab) ?? TABS[0];

  return (
    <div className="sd-page">
      {/* ========= HERO ========= */}
      <section className="sd-hero">
        <div className="sd-hero-inner">
          {/* LEFT: TEXT (no card, like Digital Marketing) */}
          <div className="sd-hero-text">
            <p className="sd-hero-kicker">SOFTWARE DEVELOPMENT SERVICES</p>
            <h1 className="sd-hero-title">
              Build, scale & modernize
              <br />
              your <span>business-critical software</span>
            </h1>
            <p className="sd-hero-sub">
              From idea to deployment, we design and develop secure, scalable
              applications for web, mobile, and cloud — aligned with your
              processes and growth plans.
            </p>

            <ul className="sd-hero-bullets">
              <li>✔ Custom business software and modules tailored to you</li>
              <li>
                ✔ Modern tech stack with React, Node.js, PostgreSQL, and cloud
                hosting
              </li>
              <li>✔ Dedicated team for long-term support and enhancements</li>
            </ul>

            <div className="sd-hero-cta-row">
              <Link to="/products">
                <button className="sd-hero-cta-primary">
                  Discuss Your Project
                </button>
              </Link>

              <Link to="/products">
                <button className="sd-hero-cta-secondary">
                  View Delivery Approach
                </button>
              </Link>
            </div>
          </div>

          {/* RIGHT: BIG IMAGE LIKE DIGITAL MARKETING HERO */}
          <div className="sd-hero-visual">
            <div className="sd-hero-visual-glow" />
            <img
              src={SoftwareDevelopments}
              alt="Software development illustration"
              className="sd-hero-image"
            />
          </div>
        </div>

        {/* stats strip */}
        <div className="sd-hero-stats-strip">
          <div className="sd-hero-stats-container">
            <div className="sd-hero-stat">
              <div className="sd-hero-stat-icon">👨‍💻</div>
              <div className="sd-hero-stat-text">
                <span className="sd-hero-stat-number">55+</span>
                <span className="sd-hero-stat-label">Software Developed</span>
              </div>
            </div>
            <div className="sd-hero-stat">
              <div className="sd-hero-stat-icon">🖥️</div>
              <div className="sd-hero-stat-text">
                <span className="sd-hero-stat-number">62+</span>
                <span className="sd-hero-stat-label">Websites Developed</span>
              </div>
            </div>
            <div className="sd-hero-stat">
              <div className="sd-hero-stat-icon">📱</div>
              <div className="sd-hero-stat-text">
                <span className="sd-hero-stat-number">25+</span>
                <span className="sd-hero-stat-label">Apps Developed</span>
              </div>
            </div>
            <div className="sd-hero-stat">
              <div className="sd-hero-stat-icon">🤝</div>
              <div className="sd-hero-stat-text">
                <span className="sd-hero-stat-number">100+</span>
                <span className="sd-hero-stat-label">Projects Delivered</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ========= WHAT WE OFFER ========= */}
      <section className="sd-offer">
        <div className="sd-offer-header">
          <h2>What We Offer</h2>
          <p>
            A complete software development stack — from clean interfaces to
            high-performing backends and reliable data layers.
          </p>
        </div>

        <div className="sd-tabs">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              className={`sd-tab ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className="sd-tabs-underline" />

        <div className="sd-tab-grid-wrapper">
          <div className="sd-tab-grid">
            {currentTab.items.map((item, index) => (
              <article
                key={item.title}
                className={`sd-tab-card ${
                  index === 1 || index === 4 ? "featured" : ""
                }`}
              >
                <div className="sd-tab-icon">{item.icon}</div>
                <h3 className="sd-tab-title">{item.title}</h3>
                <p className="sd-tab-desc">{item.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ========= DEVELOPMENT PROCESS ========= */}
      <section className="sd-process">
        <div className="sd-process-inner">
          <h3 className="sd-process-heading">Our Development Process</h3>

          <div className="sd-process-grid">
            {PROCESS_STEPS.map((step) => (
              <div key={step.label} className="sd-process-item">
                <div className="sd-process-icon-wrap">
                  <span className="sd-process-icon">{step.icon}</span>
                </div>
                <h4 className="sd-process-label">{step.label}</h4>
                <p className="sd-process-text">{step.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ========= WHY CHOOSE Aazira Solutions ========= */}
      <section className="sd-why">
        <div className="sd-why-inner">
          <h3 className="sd-why-heading">
            Why Choose Aazira Solutions for Software Development?
          </h3>

          <div className="sd-why-grid">
            {WHY_POINTS.map((item) => (
              <div key={item.title} className="sd-why-card">
                <div className="sd-why-icon">{item.icon}</div>
                <h4 className="sd-why-title">{item.title}</h4>
                <p className="sd-why-text">{item.text}</p>
              </div>
            ))}
          </div>

          <div className="sd-why-cta-row">
            <p className="sd-why-cta-text">
              Let&apos;s start a <span>new project</span> together.
            </p>

            <Link to="/contact">
              <button className="sd-why-cta-btn">Enquire Now</button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
